import React from 'react';
import {useTranslation} from 'react-i18next';
import {StatusDefect, StatusDefectGroup, getNokTotal} from '../../../../services/componentStatus';
import {StyledNokBox} from './singleComponents.style';
import {StyledInput} from '../../../../components/form/input/input.style';
import {StyledCircleButton} from '../../../../components/button/button.style';
import ArrowDownImage from '../../../../assets/images/down-arrow.svg';
import CloseImage from '../../../../assets/images/e-remove.svg';
import {ThumbDownRedImage, ThumbUpYellowImage, TrashRedImage} from '../../../../utils/styles/icons';

export type NokPartsBoxProps = {
    group: StatusDefectGroup;
    subType?: string;
    reworkedEnabled: boolean;
    reportPreview: boolean;
    formSubmitted: boolean;
    canEditDefects: boolean;
    onNokChange: (nokTotal: number) => void;
    onReworkedChange: (reworked: number) => void;
    onSelectDefect: (defectIndex: number, defect: StatusDefect) => void;
    onRemoveDefect: (defectIndex: number) => void;
    onAddDefect: () => void;
    onRemoveGroup: () => void;
};

const toInt = (value: string): number => {
    const parsed = parseInt(value.replace(/[^0-9]/g, ''), 10);
    return isNaN(parsed) ? 0 : parsed;
};

const NokPartsBox: React.FC<NokPartsBoxProps> = (props) => {
    const {t} = useTranslation();
    const defects = props.group.defects ?? [];
    const nokTotal = getNokTotal(props.group, props.subType);
    const reworked = props.group.repaired ?? 0;

    return <StyledNokBox>
        <div className="box-header">
            <div className="nok-chip">
                <img src={ThumbDownRedImage} alt=""/>
                {t('reportPage.reportForm.defects.nok')}
            </div>
            <div className="stepper">
                <button type="button" disabled={props.reportPreview || nokTotal <= 1}
                        onClick={() => props.onNokChange(nokTotal - 1)}>−</button>
                <input disabled={props.reportPreview} className="report-row-component-defects-quantity" pattern="[0-9]*" inputMode="tel" value={nokTotal}
                       onChange={(e) => props.onNokChange(toInt(e.target.value))}/>
                <button type="button" disabled={props.reportPreview}
                        onClick={() => props.onNokChange(nokTotal + 1)}>+</button>
            </div>
            {!props.reportPreview &&
                <StyledCircleButton className="white" onClick={() => props.onRemoveGroup()}>
                    <img src={TrashRedImage} alt=""/>
                </StyledCircleButton>
            }
        </div>

        {props.canEditDefects && <>
            {defects.map((defect, defectIndex) =>
                <div className="defect-row" key={'nok_defect_' + defectIndex}>
                    <div className="select-wrap" onClick={() => {
                        if (!props.reportPreview) {
                            props.onSelectDefect(defectIndex, defect);
                        }
                    }}>
                        <StyledInput readOnly={true}
                                     className={'report-row-component-defect-name' + (props.formSubmitted && !defect.name && !defect.other ? ' hasErrors' : '')}
                                     value={defect.name || defect.other || ''}
                                     placeholder={t('common.select')}/>
                        <img className="down" src={ArrowDownImage} alt=""/>
                    </div>
                    {!props.reportPreview &&
                        <StyledCircleButton className="white" onClick={() => props.onRemoveDefect(defectIndex)}>
                            <img src={CloseImage} alt=""/>
                        </StyledCircleButton>
                    }
                </div>
            )}

            {!props.reportPreview &&
                <button type="button" className="add-defect report-row-component-add-additional-defect" onClick={() => props.onAddDefect()}>
                    {t('reportPage.reportForm.addDefect')}
                </button>
            }
        </>}

        {props.reworkedEnabled &&
            <div className="reworked-row">
                <div className="label">
                    <img src={ThumbUpYellowImage} alt=""/>
                    {t('reportPage.reportForm.defects.ok')}
                </div>
                <div className="stepper">
                    <button type="button" disabled={props.reportPreview || reworked <= 0}
                            onClick={() => props.onReworkedChange(reworked - 1)}>−</button>
                    <input disabled={props.reportPreview} className="report-row-component-defects-repaired" pattern="[0-9]*" inputMode="tel" value={reworked}
                           onChange={(e) => props.onReworkedChange(toInt(e.target.value))}/>
                    <button type="button" disabled={props.reportPreview || reworked >= nokTotal}
                            onClick={() => props.onReworkedChange(reworked + 1)}>+</button>
                </div>
            </div>
        }
    </StyledNokBox>;
};

export default NokPartsBox;